import React from "react";
import "./locations.css";
import dtsp from "../../images/dtsp.png";
import east from "../../images/east.png";
import flfl from "../../images/flfl.png";

const Locations = () => {
  return (
    <div className="locations-container">
      <h1>OFFICE LOCATIONS</h1>
      <div className="locations">
        <div className="dtsp location-box">
          <h2>ST. PETERSBURG, FL</h2>
        </div>

        <div className="east location-box">
          <h2>EAST TAMPA, FL</h2>
        </div>

        <div className="flfl location-box">
          <h2>FORT LAUDERDALE, FL</h2>
        </div>
      </div>
    </div>
  );
};

export default Locations;
